module.exports = __webpack_public_path__ + "static/media/login-bg.4ae16804.png";